import React from 'react';

interface ContextType {
    user: any;
    user_internal: any
}

const UserContext = React.createContext<ContextType>({user: null, user_internal: null});

export default UserContext;